import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=13f5ea43&shadow"
import script from "./Section.vue?vue&type=script&lang=js&shadow"
export * from "./Section.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports